import http from '@/services/http';
import type { AudioPlaybackDescriptorUrl } from '@/composables/api/useAudioFileIssuesApi';

/**
 * Fetch a playable audio descriptor for a Raw DDEX track by id.
 *
 * Backed by `GET /api/track-audio/raw-ddex/{id}/descriptor` — the general
 * (non-match-scoped) endpoint, so it works for the Play column on both the
 * track-matching page and the search page. Returns a presigned `kind: 'url'`
 * descriptor the player downloads as a blob.
 */
export async function fetchRawDdexTrackAudioDescriptor(
  rawDdexTrackId: number | string,
): Promise<AudioPlaybackDescriptorUrl> {
  const { data } = await http.get<AudioPlaybackDescriptorUrl>(
    `/api/track-audio/raw-ddex/${encodeURIComponent(String(rawDdexTrackId))}/descriptor`,
  );
  return data;
}
